export class WorkflowConst {
    public static readonly WorkflowEventType = -20_000;
    public static readonly WorkflowFolderId = -20_001;
    public static readonly WorkflowCabinetId = -20_002;
}
